export class StatisticExportCriteriaDTO {
  public year: number;

  public month: string;
}
